import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { DiceRoller } from "../components/DiceRoller";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.dice_tool_name()}
        toolPath="/dice-roller"
      />
      <SciHeader title={m.dice_h1()} intro={m.dice_intro()} />
      <DiceRoller />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.dice_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.dice_ex1(), m.dice_ex2(), m.dice_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.dice_faq_q1(), a: m.dice_faq_a1() },
          { q: m.dice_faq_q2(), a: m.dice_faq_a2() },
          { q: m.dice_faq_q3(), a: m.dice_faq_a3() },
          { q: m.dice_faq_q4(), a: m.dice_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
